import React from "react";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { Error } from "./Error";

export function SelectField({
  label,
  error,
  register,
  options = [],
  disable,
  baseStyle,
}) {
  return (
    <FormControl fullWidth size="small" sx={{ ...baseStyle }} error={!!error}>
      <InputLabel>{label}</InputLabel>

      <Select
        label={label}
        disabled={disable}
        defaultValue="" // 👈 MUST
        sx={{ mb: error ? 0 : 2 }}
        {...register} // 👈 as-is pass
      >
        {/* Empty option required validation ke liye */}
        <MenuItem value="">
          <em>Select {label}</em>
        </MenuItem>

        {options.map((item) => (
          <MenuItem key={item.value} value={item.value}>
            {item.label}
          </MenuItem>
        ))}
      </Select>

      {error && <Error message={error} />}
    </FormControl>
  );
}
